<template>
  <div>
    <Overcharts class="chart" :options="chartOptions" :updateArgs="updateArgs" ref="overchart"></Overcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";
import { EventBus } from "@/event-bus.js";

stockInit(Highcharts);
exportingInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

export default {
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    Overcharts: Chart
  },

  created() {
    EventBus.$on("btn-clicked", data => {
      this.chartOptions.series[0].data = data.newData;
    });
  },

  data() {
    return {
      updateArgs: [true, true, true],
      chartOptions: {
        chart: {
          type: "column"
        },
        title: {
          text: "Global Non-CO₂ Emissions by Gas (MtCO₂e)"
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: ["1990", "2000", "2015", "2030", "2050"]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Emissions (MtCO₂e)"
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color:
                // theme
                (Highcharts.defaultOptions.title.style &&
                  Highcharts.defaultOptions.title.style.color) ||
                "gray"
            }
          }
        },

        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            "{series.name}: {point.y:,.0f}<br/>Total: {point.stackTotal:,.0f}"
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [
          {
            name: "N₂O",
            data: [2500, 2700, 3200, 3850, 4240]
          },
          {
            name: "F-GHGs",
            data: [317, 400, 950, 1331, 2056]
          },
          {
            name: "CH₄",
            data: [6500, 6742, 7860, 8850, 10200]
          }
        ]
      }
    };
  }
};
</script>
